import React from "react";
import { Box, Stack, Typography, Skeleton, useTheme } from "@mui/material";
import { t } from "i18next";

const buttonStyle = {
  height: 40,
};

const AppointmentDetailsSkeleton = () => {
  const { palette } = useTheme();

  return (
    <>
      <Stack height={"100vh"} justifyContent={"space-between"}>
        {/* Header Skeleton */}
        <Stack
          p={2}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          borderBottom={`1px solid ${palette.custom.borderColor}`}
        >
          <Box>
            <Skeleton variant="text" width={150} height={30} />
            <Skeleton variant="text" width={100} height={20} />
          </Box>
          <Box>
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={100} height={20} />
          </Box>
        </Stack>

        {/* Services Skeleton */}
        <Box p={2} height={"100%"} overflow={"auto"}>
          <Typography fontSize={"1.125rem"}>{t("services")}</Typography>
          <Stack spacing={2} mt={2}>
            {[1, 2, 3].map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                height={80}
                width={"100%"}
                sx={{ borderRadius: "8px" }}
              />
            ))}
          </Stack>

          <Skeleton
            variant="rectangular"
            height={60}
            width={"100%"}
            sx={{
              borderRadius: "8px",
              mt: 2,
            }}
          />
        </Box>

        {/* Footer Skeleton */}
        <Stack
          spacing={0.5}
          p={2}
          borderTop={`1px solid ${palette.custom.borderColor}`}
        >
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Skeleton variant="text" width={80} height={20} />
            <Stack direction={"row"} alignItems={"center"} gap={3}>
              <Skeleton variant="text" width={50} height={20} />
              <Skeleton variant="text" width={80} height={20} />
            </Stack>
          </Stack>
          <Stack direction={"row"} spacing={1} mt={1}>
            <Skeleton
              variant="rectangular"
              height={40}
              width={"100%"}
              sx={{ borderRadius: "8px" }}
            />
            <Skeleton
              variant="rectangular"
              height={40}
              width={"100%"}
              sx={{ borderRadius: "8px" }}
            />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default AppointmentDetailsSkeleton;
